<template>
  <div class="layout2" style="background: #f2f5f7">
    <div class="headbg" v-show="status">
      <img :src="require(`@/assets/image/anxin/tou.png`)" />
    </div>
    <div class="laytab">
      <van-tabs v-model="activeName" class="vantabs peaceTab mytabsOver" type="card" sticky :ellipsis="false"
        @click="onClick" color="#008DEF" animated line-height="3px" title-active-color="#fff" background="#1F1FF">
        <van-tab v-for="item in navData" :key="item.text" :title="item.text" :name="item.text">
          <component v-if="item.show" :is="item.url" :list.sync="item.data" :marks="marks" :status="status" :st="st"
            :qsfx="qsfx" :sl="sl" @fatherMethod="fatherMethod"></component>
        </van-tab>
      </van-tabs>
    </div>
    <van-dialog class="peaceComDialog" v-model="showSuccess" title="健康分数说明" messageAlign="left"
      confirmButtonColor="#A7DDFF" closeOnClickOverlay confirmButtonText="关闭" theme="round-button" width="320"
      className="peaceH5dialogText">
      <markbox :item="fsSta"></markbox>
    </van-dialog>
  </div>
</template>
<script>
import comment from "./components/comment.vue";
import physiology from "./components/physiology.vue";
import translate from "./components/translate.vue";
import Report from "../../models/Report";
import markbox from "./components/markBox.vue"
import { Toast } from 'vant';
export default {
  components: { comment, physiology, markbox, translate },
  data() {
    return {
      activeName: '健康总评',
      marks: 0,
      status: true,
      st: {},
      sl: {},
      showSuccess: false,
      fsSta: {
        status: '优',
        level: 4,
        value: 85
      },
      qsfx: {
        xAxis: [],
        series: []
      },
      navData: [
        {
          text: '健康总评', url: 'comment', show: true, data: [
          ]
        },
        {
          text: '生理系统', url: 'physiology', show: true, data: {}
        },
        {
          text: '营养状态', url: 'physiology', show: true, data: {}
        },
        {
          text: '有害物质', url: 'physiology', show: true, data: {}
        }
        // {
        //   text: '人体成分', url: 'translate', show: true, data: {}
        // }
      ],
    }
  },
  computed: {
    id() {
      return this.$route.query.id || "";
    },
    user_no() {
      return this.$route.query.user_no || "";
    },
  },
  mounted() {
    localStorage.setItem("token", this.$route.query.token);
  },
  created() {
    localStorage.removeItem('conditionData')
    localStorage.removeItem('systemData')
    localStorage.removeItem('systemContentData')
    Toast.loading({
      message: '加载中...',
      forbidClick: true,
      className: 'tianlei',
      duration: 0,
      loadingType: 'spinner',
    });
    let params = {
      user_no: this.user_no, //this.user_no  808d43890c52c5901a26a9b8e80e0f47
      test_report_id: this.id,//this.id 4388
    };
    let params1 = {
      user_no: this.user_no, //this.user_no  808d43890c52c5901a26a9b8e80e0f47

      keyword: '多维健康评估'
    };
    Report.getReports({ ...params }, (res, err) => {
      console.log(res)
      if (this.compareDates(res.created_at.slice(0, 10), '2024-03-22')) {
        // 第一个时间小于第二个时间 进这里
        this.$router.push({ path: '/PeaceMindH5Old', query: {user_no: this.user_no,id: this.id,token:  this.$route.query.token} });
      }else{
        if (!err) {
        res.risk.forEach((item) => {
         try {
          item.performance = item.performance.split('<b>').join('<b style="margin-bottom:5px;margin-top:10px;display:inline-block">')
          item.suggestion = item.suggestion.split('<b>').join('<b style="margin-bottom:5px;margin-top:10px;display:inline-block">')
          item.performance = item.performance ? item.performance.split('\\r\\n') : []
          item.suggestion = item.suggestion ? item.suggestion.split('\\r\\n') : []
          this.navData[0].data.push(item)
         } catch (error) {
          
         }
        })
        this.navData[1].data = res.slxt // 生理系统
        this.navData[1].data.son.push(res.pfxt) // 生理系统增加皮肤系统

        this.navData[2].data = res.yyzt // 营养状态
        this.navData[3].data = res.yhwz // 有害物质
        // this.navData[4].data = res.rtcffx // 人体成分

        this.navData[1].data.son.forEach((item) => {
          item.son.forEach((itemA) => {
            itemA.son.forEach((itemB) => {
              if (itemB.performance) {
                itemB.performance = itemB.performance.split('<b>').join('<b style="margin-bottom:5px;margin-top:10px;display:inline-block">')
                itemB.suggestion = itemB.suggestion.split('<b>').join('<b style="margin-bottom:5px;margin-top:10px;display:inline-block">')
                itemB.performance = itemB.performance ? itemB.performance.split('\\r\\n') : []
                itemB.suggestion = itemB.suggestion ? itemB.suggestion.split('\\r\\n') : []
              }
            })
          })
          item.gs = item.risk.length
        })
        this.navData[2].data.son.forEach((item) => {
          item.son.forEach((itemA) => {
            if (itemA.performance) {
              itemA.performance = itemA.performance.split('<b>').join('<b style="margin-bottom:5px;margin-top:10px;display:inline-block">')
              itemA.suggestion = itemA.suggestion.split('<b>').join('<b style="margin-bottom:5px;margin-top:10px;display:inline-block">')
              itemA.performance = itemA.performance ? itemA.performance.split('\\r\\n') : []
              itemA.suggestion = itemA.suggestion ? itemA.suggestion.split('\\r\\n') : []
            }
          })
          item.gs = item.risk.length
        })
        this.navData[3].data.son.forEach((item) => {
          item.son.forEach((itemA) => {
            if (itemA.performance) {
              itemA.performance = itemA.performance.split('<b>').join('<b style="margin-bottom:5px;margin-top:10px;display:inline-block">')
              itemA.suggestion = itemA.suggestion.split('<b>').join('<b style="margin-bottom:5px;margin-top:10px;display:inline-block">')
              itemA.performance = itemA.performance ? itemA.performance.split('\\r\\n') : []
              itemA.suggestion = itemA.suggestion ? itemA.suggestion.split('\\r\\n') : []
            }
          })
          item.gs = item.risk.length
        })
        // this.navData[4].data.forEach((item) => {
        //   if (item.name == '基础代谢' || item.name == '体重指数') {
        //     item.danwei = ""
        //   } else {
        //     item.danwei = "kg"
        //   }
        // })
        this.marks = res.jkzp.son[0].value
        this.st = res.jkzp.son[1]
        this.st.gs = res.jkzp.son[1].risk.length
        this.activeName = this.$store.state.activeName
        //this.activeName = localStorage.getItem('activeName') ? localStorage.getItem('activeName') : '健康总评'
        this.activeName == '健康总评' ? this.status = true : this.status = false
        setTimeout(() => {
          Toast.clear()
        }, 1500)
        // 模拟回到顶部
        // this.$nextTick(() => {
        //   window.scrollTo(0, 1);

        //   window.scrollTo(0, 0);
        // })


      }
      }
    
    });
    Report.getReportList({ ...params1 }, (res, err) => {

      if (!err) {
        this.qsfx.series = []
        this.qsfx.xAxis = []
        res.data.forEach((item) => {

          this.qsfx.series.push(item.marks)
          this.qsfx.xAxis.push(item.updated_at)
        })


      }
    });

  },
  methods: {
    compareDates(d1, d2) {
      // 将日期字符串转换为 Date 对象
      let date1 = new Date(d1.replace(/-/g, '/')); // 使用正则表达式将短横线替换为斜杠，以适配 Date 构造函数
      let date2 = new Date(d2.replace(/-/g, '/'));
      // 比较两个日期对象
      if (date1 < date2) {
        return true; // date1 在 date2 之前
      } else {
        return false; // date1 在 date2 之后
      }
    },
    onClick(name, title) {
      this.$store.commit('changeActiveName', title)
      // localStorage.setItem("activeName", );
      title == '健康总评' ? this.status = true : this.status = false
      document.title = title == '健康总评' ? '多维健康评估' : title
    },
    fatherMethod() {
      this.showSuccess = true
    },
    keynoteLink() {
      this.$router.push({ path: '/reportComparison', query: { user_no: this.user_no } });

    }
  },
  updated() {
    document.scrollingElement.scrollTop = 0
  },
}
</script>
<style lang="scss" >
.layout2 {
  box-sizing: border-box;
  min-height: 100vh;
  text-align: left;
  display: inline-block;
  width: 100%;
  padding-bottom: 30px;

  .van-sticky--fixed {
    background: #fff;
    padding-top: 20px;
    box-shadow: 0px 10px 13px 0px rgba(232, 232, 232, 0.3) !important;

    .van-tabs__wrap {
      height: 80px !important;
    }

    .van-tab {
      box-shadow: 0 !important;
    }
  }

  .laytab {
    position: relative;
    z-index: 2;
  }

  .headbg {
    width: 100%;
    height: 533px;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .vantabs {
    padding-bottom: 0;
  }
}

.peaceComDialog {
  .van-button__text {
    font-size: 28px;
  }
}

.tianlei {
  padding: 20px !important;
  font-size: 26px !important;
}

.tianlei .van-toast__text {
  font-size: 26px !important;
}

.van-toast {
  width: auto !important;
}

.pointImg {
  img {
    width: 40px;
    height: 49px;
    vertical-align: middle;
    margin-right: 10px;
  }
}

.peaceH5dialogText {
  .van-dialog__message--left {
    line-height: 28px;
    font-size: 24px;
    color: #333;
  }

  .van-dialog__header {
    background: #a7ddff;
    padding-top: 0;
    height: 80px;
    line-height: 80px;

    color: #008def;
    font-size: 26px;
  }

  .van-button__text {
    font-size: 28px;
  }
}

.rtcfClass {
  text-align: left;
}

.rtcfStyPad {
  .van-cell__value {
    padding-top: 20px;
    font-size: 26px;
    flex: 0.5;
    padding-right: 20px;
    overflow: auto
  }

  .van-icon {
    padding-top: 20px;
  }
}

.peaceTab {
  padding-top: 30px;

  .van-cell {
    padding: 30px 20px !important;
    font-size: 30px !important;
  }

  .van-collapse-item--border::after {
    border-color: #e3e1e1;
  }

  .van-tabs__nav--card {
    height: 100px !important;

    .van-tab {
      width: 160px !important;
      height: 60px !important;
      background: #e1f1ff;
      box-shadow: 0px 10px 13px 0px rgba(47, 153, 231, 0.3);
      border-radius: 30px;
      margin-right: 20px;
      padding: 0 !important;

      flex: 0 0 24% !important;
    }
  }

  .van-cell__value {
    padding-top: 20px;
    font-size: 26px;
    flex: 0.5;
    padding-right: 20px;
  }

  .van-cell__right-icon {
    margin-top: 20px !important;
  }

  .van-tab__text {
    font-size: 28px;
  }

  .van-tab--active {
    width: 160px !important;
    height: 60px !important;
    background: #008def !important;
    border: 1px solid #fff !important;
    box-shadow: 0px 10px 13px 0px rgba(47, 153, 231, 0.3) !important;
    border-radius: 30px !important;
  }

  .van-tabs__wrap {
    height: 100px !important;
  }

  .van-tabs__nav {
    background: none;
    border: none;
  }

  .van-tabs__content--animated {
    padding-top: 0;
  }
}

.mytabTT {
  .van-cell__right-icon {
    margin-top: 0px !important;
  }

  .van-cell__value {
    padding-top: 0px !important;
  }
}
</style>